export const initialLastEngagement = ['Last ELT engagement date/contact | Outcome: XXX']
